import Button from '@/components/Button.jsx';
import { FiSettings } from '@/components/react-icons/main';
import useResponsive from '@/hooks/useResponsive.js';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors.js';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { handleOpenTestCredentials } from '../workflowEditorPanels/primaryPanels/appPanel/lib/handleOpenTestCredentials';

const WorkflowTestCredentialsButton = memo(() => {
  const [isLoading, setIsLoading] = useState(false);
  const { tablet } = useResponsive();
  const activeWorkflowId = useSelector((state) => workflowScreenSelectors.activeWorkflow(state)?.id);
  const activeWorkflowIntegrationId = useSelector(workflowScreenSelectors.activeWorkflowIntegrationId);
  const activeWorkflowTestInstallationId = useSelector(workflowScreenSelectors.activeWorkflowTestInstallationId);
  const embeddedIntegration = useArgSelector(selectors.embeddedIntegrationById, activeWorkflowIntegrationId);
  const isDraft = useSelector((state) => selectors.param(state, 'workflowVersion') === 'draft');

  // Only show if we're in an embedded workflow (has integration ID and embedded integration data)
  const shouldShow = activeWorkflowIntegrationId && embeddedIntegration;

  if (!shouldShow || !isDraft) {
    return null;
  }

  const buttonText = tablet ? 'Edit Test Creds' : 'Edit Test Credentials';
  const handleClick = () => handleOpenTestCredentials({ installationId: activeWorkflowTestInstallationId, integrationId: activeWorkflowIntegrationId, workflowId: activeWorkflowId, setLoading: setIsLoading });

  return (
    <Button className={'secondary test-credentials-button'} icon={FiSettings} onClick={handleClick} loading={isLoading} disabled={isLoading}>
      {buttonText}
    </Button>
  );
});

WorkflowTestCredentialsButton.displayName = 'WorkflowTestCredentialsButton';

export default WorkflowTestCredentialsButton;
